__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-common/v10_15_21/";